(function () {
  var FREE = 130000;
  var fmt = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function shipHTML(total) {
    var left = FREE - total;
    var pct = Math.max(0, Math.min(100, (total / FREE) * 100));
    var free = left <= 0;
    return '<div class="landa-ship' + (free ? ' is-free' : '') + '" data-landa-ship>' +
      '<p>' + (free ? '<b>¡Tienes despacho gratis!</b>' : 'Te faltan <b>' + fmt(left) + '</b> para el <b>despacho gratis</b>') + '</p>' +
      '<div class="landa-ship__bar"><span style="width:' + pct + '%"></span></div>' +
      '<p class="landa-ship__fine">Despacho gratis sobre $130.000 · Plazo de entrega: 1 a 5 días hábiles · Envío a todo Chile con Chilexpress; el costo se calcula al finalizar la compra según tu comuna.</p></div>';
  }

  var lastCart = null, busy = false, timer;
  function targets() { return $$('.cart-drawer__footer .totals, #main-cart-footer .totals'); }
  function paintShip() {
    if (!lastCart) return;
    var html = shipHTML(lastCart.total_price / 100);
    targets().forEach(function (t) {
      var prev = t.parentNode.querySelector('[data-landa-ship]');
      if (lastCart.item_count === 0) { if (prev) prev.remove(); return; }
      if (prev) { prev.outerHTML = html; return; }
      t.insertAdjacentHTML('beforebegin', html);
    });
  }
  function refreshCart() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; paintShip(); }).catch(function () {}).then(function () { busy = false; });
  }
  function check() {
    var t = targets();
    if (t.some(function (x) { return !x.parentNode.querySelector('[data-landa-ship]'); })) refreshCart();
  }
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(check, 200); })
    .observe(document.body || document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', check);

  /* Ficha: sin talla preseleccionada + botón fijo mobile */
  function initPDP() {
    var info = $('product-info');
    var picker = $('variant-selects');
    var btn = $('.product-form__submit');
    if (!info || !btn) return;
    var priceTxt = function () {
      var p = $('.product__info-container .price-item--sale') || $('.product__info-container .price-item--regular');
      return p ? p.textContent.trim() : '';
    };
    var needSize = false;
    var hasVariantParam = /[?&]variant=/.test(location.search);
    if (picker && !hasVariantParam) {
      $$('fieldset', picker).forEach(function (fs) {
        var legend = ($('legend', fs) || {}).textContent || '';
        if (!/talla|size|n[uú]mero/i.test(legend)) return;
        var radios = $$('input[type=radio]', fs);
        if (radios.length < 2) return;
        radios.forEach(function (r) { r.checked = false; });
        needSize = true;
        fs.setAttribute('data-landa-size', '');
      });
    }
    var origLabel = '';
    function setNeed(on) {
      var b = $('.product-form__submit');
      if (!b) return;
      var s = $('span', b) || b;
      if (on) {
        origLabel = origLabel || s.textContent.trim();
        s.textContent = 'Elige tu talla';
        b.setAttribute('aria-disabled', 'true');
        b.classList.add('landa-need');
      } else if (b.classList.contains('landa-need')) {
        b.classList.remove('landa-need');
        b.removeAttribute('aria-disabled');
        if (origLabel) s.textContent = origLabel;
      }
    }
    if (needSize) {
      setNeed(true);
      info.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') { needSize = false; setNeed(false); }
      });
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.product-form__submit.landa-need');
        if (!b) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var fs = $('[data-landa-size]');
        if (fs) { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); fs.classList.add('landa-need-size'); setTimeout(function () { fs.classList.remove('landa-need-size'); }, 1200); }
      }, true);
      var form = $('product-form form');
      if (form) form.addEventListener('submit', function (e) { if (needSize) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
    }

    var bar = document.createElement('div');
    bar.className = 'landa-sticky-atc';
    bar.innerHTML = '<span class="landa-sticky-atc__price"></span><button type="button" class="landa-sticky-atc__btn"></button>';
    document.body.appendChild(bar);
    var bBtn = $('.landa-sticky-atc__btn', bar), bPrice = $('.landa-sticky-atc__price', bar);
    bBtn.addEventListener('click', function () {
      var b = $('.product-form__submit');
      if (b) b.click();
    });
    function sync() {
      var b = $('.product-form__submit');
      if (!b) return;
      bBtn.textContent = ($('span', b) || b).textContent.trim();
      bBtn.disabled = b.disabled && !b.classList.contains('landa-need');
      bPrice.textContent = priceTxt();
    }
    sync();
    var visible = true;
    var io = new IntersectionObserver(function (en) {
      visible = en[0].isIntersecting;
      bar.classList.toggle('is-on', !visible);
    }, { threshold: 0 });
    var watched = null;
    function watch() {
      var b = $('.product-form__submit');
      if (b && b !== watched) { if (watched) io.unobserve(watched); watched = b; io.observe(b); }
    }
    watch();
    new MutationObserver(function () { sync(); watch(); }).observe(info, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('DOMContentLoaded', initPDP);
})();
